import { Component, OnInit } from '@angular/core';
import { ActivatedRoute,Router } from '@angular/router';
import { AuthService } from 'src/app/core/services/auth.service';
import { buildAuthAsRedirectUrl } from './auth-as-route';

@Component({
  selector: 'auth-as',
  template: ``,
  styles: []
})
export class AuthAsComponent implements OnInit {

  redirectTo:string = "/buyer-home";
  selectedItem:string;
  authAsUserId : string ;

  constructor(private route: ActivatedRoute,private router:Router, private authService: AuthService) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params =>{
        this.redirectTo = params?.redirectTo;
        this.selectedItem = params?.selectedItem;
    })

    this.authService.authAs().then(()=>{
      this.authService.checkAuthAs();
      this.goTo();
    });
  }

  private goTo() {
    const url = buildAuthAsRedirectUrl(this.redirectTo, this.selectedItem);
    localStorage.setItem('auhtAsRedirectUrl', url);
    this.router.navigateByUrl(url);
    }
}
